import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./components/home/Home";
import AllResults from "./components/all/AllResults";
import './App.css';

const App = () => {
  return (
    <Router>
      <div style={{ padding: "10px", fontFamily: "Arial" }}>
        <Routes>
          <Route path="/" element={<Home sd="s"/>} />
          <Route path="/n" element={<Home sd="n" />} />
          <Route path="/all" element={<AllResults />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
